import { DISCARDED, ErrorSource, buildTags, combine, createEventRateLimiter, getRelativeTime } from '@datadog/browser-core';
import { STATUSES } from './logger';
export function startLogsAssembly(configuration, lifeCycle, hooks, getCommonContext, reportError) {
  var statusWithCustom = STATUSES.concat(['custom']);
  var logRateLimiters = {};
  statusWithCustom.forEach(function (status) {
    logRateLimiters[status] = createEventRateLimiter(status, configuration.eventRateLimiterThreshold, reportError);
  });
  lifeCycle.subscribe(0
  /* LifeCycleEventType.RAW_LOG_COLLECTED */
  , function (_ref) {
    var rawLogsEvent = _ref.rawLogsEvent,
        _ref$messageContext = _ref.messageContext,
        messageContext = _ref$messageContext === void 0 ? undefined : _ref$messageContext,
        _ref$savedCommonConte = _ref.savedCommonContext,
        savedCommonContext = _ref$savedCommonConte === void 0 ? undefined : _ref$savedCommonConte,
        domainContext = _ref.domainContext,
        _ref$ddtags = _ref.ddtags,
        ddtags = _ref$ddtags === void 0 ? [] : _ref$ddtags;

    var _a, _b;

    var startTime = getRelativeTime(rawLogsEvent.date);
    var commonContext = savedCommonContext || getCommonContext();
    var defaultLogsEventAttributes = hooks.triggerHook(0
    /* HookNames.Assemble */
    , {
      startTime: startTime
    });

    if (defaultLogsEventAttributes === DISCARDED) {
      return;
    }

    var defaultDdtags = buildTags(configuration);
    var log = combine({
      view: commonContext.view
    }, defaultLogsEventAttributes, rawLogsEvent, messageContext, {
      ddtags: defaultDdtags.concat(ddtags).join(',')
    });

    if (((_a = configuration.beforeSend) === null || _a === void 0 ? void 0 : _a.call(configuration, log, domainContext)) === false || log.origin !== ErrorSource.AGENT && ((_b = logRateLimiters[log.status]) !== null && _b !== void 0 ? _b : logRateLimiters['custom']).isLimitReached()) {
      return;
    }

    lifeCycle.notify(1
    /* LifeCycleEventType.LOG_COLLECTED */
    , log);
  });
}